import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from '../../../base.service';
import { BehaviorSubject } from 'rxjs';


export class ProductModal {
  createdOnUTC!: string;
  displayOrder!: string;
  id!: string;
  isActive!: string;
  licenseDurationType!: string;
  productCode!: string;
  productDOCPath!: string;
  productImagePath!: string;
  productName!: string;
  productURL!: string;
  updatedOnUTC!: string;
  file!: File;
  isCentralAllowed!:any
  commitmentDuration!:any
  cancellationRate!:any
  graceDays!:any
}

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(private http: HttpClient, private BaseService: BaseService) {
  
  }

  ProductData : ProductModal = new ProductModal();

  private storageKey = 'productData';
  savedData = localStorage.getItem(this.storageKey);
  private selectedProductDatadataSource = new BehaviorSubject<ProductModal | null>(this.savedData ? JSON.parse(this.savedData) : null);;
  selectedProductData = this.selectedProductDatadataSource.asObservable();
  selectedProductDataUpdate(data: ProductModal) {
    console.log("🚀 > ProductsService > selectedProductDataUpdate > data:", data);
    this.selectedProductDatadataSource.next(data);
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }



  
  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getProducts() {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/Products/GetAll', {
      headers,
    });
  }

  addProduct(ProductData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Products/Add', ProductData, {
      headers,
    });
  }

  editProduct(ProductData: any) {
    const headers = this.getHeaders();
    return this.http.post(this.BaseService.BASEURL + '/api/MS/Products/Edit', ProductData, {
      headers,
    });
  }

  deleteProduct(id: string) {
    const headers = this.getHeaders();
    return this.http.get(this.BaseService.BASEURL + '/api/MS/Products/Delete/' + id, {
      headers,
    });
  }
}
